const contactKeys = {
  all: ['crmContact'],
  search: (query: string) => [...contactKeys.all, 'search', query],
  byContactId: (id: string) => [...contactKeys.all, id]
};

export default contactKeys;
